
import Store from '../store/Store'
import NiceData from '../data/NiceData'
import DataHelpers from '../helpers/DataHelpers'

export default class {

    static setTenant(tenantKey) {
        if(tenantKey == Store.getters.tenantKey)
            return

        Store.commit('setTenant', {key: tenantKey})
        console.log('Tenant changed to ' + tenantKey)
    }
    static fetchInvite(tenantKey) {
        return new Promise( (resolve, reject) => {
            const ref = DataHelpers.getRootRef().child('invites').child(tenantKey)
            NiceData.fetchItemSingle(ref).then(item => {
                resolve(item)
            }).catch(err => {
                reject (err)
            })         
        })
    }




        
}


// WEBPACK FOOTER //
// ./src/helpers/TenantHelpers.js